 
import { EntityConstants } from '../../helpers/general.helper';
 
export const especialidadesConstants: EntityConstants = {
	apiEndpoint: '/api/especialidades',
	navigateToParent: '/med/especialidades',
	entityLabel: 'Especialidad',
	entityLabelGender: 'F',
}
 
export interface Especialidad {
	id: number;
	nombre: string;
	activo: boolean;
}
 
 
 
